import './styles.css';
import * as Sentry from '@sentry/react';
import { StrictMode } from 'react';
import * as ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';

import { App } from './app/app';
import { ApolloProvider } from './app/providers/apollo-provider';
import { environment } from './environments/environment';
import { initGtm, pushPageView } from './app/shared/utils/gtm';

if (environment.sentry.enabled) {
  Sentry.init({
    dsn: environment.sentry.dsn,
    environment: environment.sentry.environment,
    release: environment.version,
    sendDefaultPii: true,
  });
}

console.log(`iQD Budget Calculator ${environment.version}`);

initGtm({ id: environment.gtm.id, enabled: environment.gtm.enabled });
pushPageView(window.location.pathname);

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement);
root.render(
  <StrictMode>
    <BrowserRouter>
      <ApolloProvider>
        <App />
      </ApolloProvider>
    </BrowserRouter>
  </StrictMode>,
);
